import { useId } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { SERVICE_COLOR_PALETTE } from '@/lib/zodSchemas/service';

interface ColorPickerProps {
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
}

export function ColorPicker({ value, onChange, invalid }: ColorPickerProps) {
  const inputId = useId();
  const normalized = value?.toLowerCase() ?? '';
  return (
    <div className="flex flex-col gap-2">
      <div role="radiogroup" aria-label="Paleta de cores do serviço" className="flex flex-wrap gap-2">
        {SERVICE_COLOR_PALETTE.map((c) => {
          const selected = normalized === c.toLowerCase();
          return (
            <button
              key={c}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={`Cor ${c}`}
              onClick={() => onChange(c)}
              className={cn(
                'h-8 w-8 rounded-full border-2 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--color-accent)',
                selected ? 'border-(--color-fg) scale-110' : 'border-transparent',
              )}
              style={{ backgroundColor: c }}
            />
          );
        })}
      </div>
      <div className="flex items-center gap-2">
        <label htmlFor={inputId} className="text-xs text-(--color-fg-muted)">
          Hex custom
        </label>
        <Input
          id={inputId}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#RRGGBB"
          invalid={invalid}
          className="h-9 w-32 font-mono text-xs"
          maxLength={7}
        />
        <span
          aria-hidden
          className="h-8 w-8 rounded-md border border-(--color-border)"
          style={{ backgroundColor: /^#[0-9A-Fa-f]{6}$/.test(value) ? value : 'transparent' }}
        />
      </div>
    </div>
  );
}
